import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M21.5199 8.532C21.2939 8.379 20.9819 8.435 20.8259 8.664L19.7869 10.193C18.9599 6.634 15.7629 4 11.9999 4C8.61392 4 5.58192 6.144 4.45492 9.334C4.36292 9.595 4.49992 9.88 4.75992 9.973C5.02192 10.062 5.30592 9.928 5.39792 9.668C6.38392 6.875 9.03692 5 11.9999 5C15.3069 5 18.1159 7.326 18.8219 10.461L17.1969 9.356C16.9709 9.202 16.6589 9.259 16.5029 9.488C16.3469 9.717 16.4059 10.028 16.6349 10.183L19.2079 11.933C19.2319 11.949 19.2619 11.946 19.2879 11.958C19.2999 11.963 19.3119 11.965 19.3239 11.969C19.3789 11.989 19.4299 12.02 19.4889 12.02C19.5199 12.02 19.5509 12.017 19.5829 12.011C19.7129 11.986 19.8279 11.91 19.9019 11.801L21.6509 9.227C21.8069 8.998 21.7479 8.687 21.5199 8.532V8.532Z"
      fill="currentColor"
    />
    <path
      d="M19.2309 14.027C18.9689 13.935 18.6859 14.071 18.5919 14.332C17.6059 17.124 14.9529 19 11.9909 19C8.68391 19 5.87591 16.674 5.16891 13.539L6.79391 14.643C7.02491 14.799 7.33391 14.74 7.48891 14.511C7.64391 14.282 7.58491 13.972 7.35691 13.817L4.78291 12.067C4.67291 11.993 4.53891 11.965 4.40791 11.99C4.27691 12.015 4.16291 12.091 4.08791 12.2L2.33891 14.774C2.18391 15.003 2.24291 15.314 2.47091 15.468C2.55691 15.527 2.65491 15.555 2.75191 15.555C2.91191 15.555 3.06891 15.479 3.16591 15.336L4.20491 13.807C5.03091 17.365 8.22891 20 11.9909 20C15.3769 20 18.4079 17.856 19.5359 14.666C19.6279 14.405 19.4909 14.119 19.2309 14.027V14.027Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Refresh');

export default Icon;
